
import * as defaultImport from "@splunk/visualization-context/ZoomContext";
export * from "@splunk/visualization-context/ZoomContext";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
